import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { Trash2, Pencil, Clock, ChevronLeft, ChevronRight, ArrowLeft } from "lucide-react";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import releveHeuresService from "../../services/releveHeuresService";
import { toast } from "react-toastify";




// Données mock pour simuler un relevé d'heures
const mockTimeSheet= {
  id: "TS-20241209",
  weekNumber: 3,
  year: 2024,
  startDate: "09/12/2024",
  endDate: "15/12/2024",
  employeeName: "KUMBA MHRIA",
  employeePosition: "MANUTENTIONNAIRE",
  employeeCompany: "LES GARTRES",
  employeeId: "1412_5",
  hours: {
    "lundi": "7.5",
    "mardi": "7.5",
    "mercredi": "7.5",
    "jeudi": "7.5",
    "vendredi": "7.5",
    "samedi": "",
    "dimanche": ""
  },
  nightHours: {
    "lundi": "",
    "mardi": "2",
    "mercredi": "",
    "jeudi": "",
    "vendredi": "",
    "samedi": "",
    "dimanche": ""
  },
  absences: {
    "lundi": "",
    "mardi": "",
    "mercredi": "",
    "jeudi": "",
    "vendredi": "",
    "samedi": "",
    "dimanche": ""
  },
  status: "pending",
  clientComment: "",
  employeeComment: "",
  projectNumber: "CH-2024-103",
  endOfMission: false,
  clientRating: 0,
  clientRatingComment: ""
};
const mockTimeSheets = [mockTimeSheet];
// Jours de la semaine avec leurs dates pour la semaine courante
const weekDays = [
  { name: "Lundi", date: "13/01", key: "lundi" },
  { name: "Mardi", date: "14/01", key: "mardi" },
  { name: "Mercredi", date: "15/01", key: "mercredi" },
  { name: "Jeudi", date: "16/01", key: "jeudi" },
  { name: "Vendredi", date: "17/01", key: "vendredi" },
  { name: "Samedi", date: "18/01", key: "samedi" },
  { name: "Dimanche", date: "19/01", key: "dimanche" }
];

const heures = [
    "Heures diverses", "Heures d'entretien annuel","Heures de formation", "Heures de pause", "Heures de réunion" ,"Heures de route", "Heures visite médicale"
  ];

const primes = [
    "Prime 13e mois", "Prime d’assiduité", "Prime d’ancienneté", "Prime d’astreinte",
    "Prime d’encadrement", "Prime de fonction", "Prime de salissure", "Prime de pénibilité", "Prime de performance",
    "Prime de productivité", "Prime de remplacement", "Prime de responsabilité", "Prime de rendement", "Prime de caissier(e)",
    "Prime de déménagement", "Prime de fin d’année", "Prime de froid", "Prime de jours fériés", "Prime de mariage",
    "Prime de maîtrise", "Prime de nuit", "Prime de panier", "Prime de ponctualité", "Prime de prestation",
    "Prime de résultats", "Prime de secrétariat", "Prime de sujétion", "Prime de vacances", "Prime exceptionnelle",
    "Prime Macron / PPV", "Prime de non-concurrence", "Prime de départ en retraite", "Prime de polyvalence", "Prime de danger"
  ];

const indemnites = [
    "Indemnité de déplacement", "Indemnité de départ volontaire", "Indemnité de formation",
    "Indemnité de fonction", "Indemnité de logement", "Indemnité de non-concurrence", "Indemnité de sujétion",
    "Indemnité de trajet", "Indemnité de transport", "Indemnité de repas", "Indemnité de panier", "Indemnité kilométrique"
  ];

const heureOptions = heures.map((heure) => ({
  value: heure.toLowerCase().replace(/\s+/g, '_'),
  label: heure,
}))

const primeOptions = primes.map((prime) => ({
  value: prime.toLowerCase().replace(/\s+/g, '_'),
  label: prime,
}))

const indemniteOptions = indemnites.map((indemnite) => ({
  value: indemnite.toLowerCase().replace(/\s+/g, '_'),
  label: indemnite,
}))
const RelevesHeures = ({ timesheetId, initialTimesheet, onClose, isOverlay = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [timeSheet, setTimeSheet] = useState(null);
  const [hourFormat, setHourFormat] = useState("minutes");
  const [nightHoursOption, setNightHoursOption] = useState("included"); // Inclus dans les heures de jour ou additionnel
  const [weekHoursOption, setweekHoursOption] = useState("35h");
  const [clientComment, setClientComment] = useState("");
  const [employeeComment, setEmployeeComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [clientRating, setClientRating] = useState(0);
  const [clientRatingComment, setClientRatingComment] = useState("");
  const [primes, setPrimes] = useState([]);
  const [indemnites, setIndemnites] = useState([]);
  const [heures, setHeures] = useState([]);
  const [selectedPrime, setSelectedPrime] = useState(null);
  const [quantitePrime, setQuantitePrime] = useState('');
  const [montantPrime, setMontantPrime] = useState('');
  const [selectedIndemnite, setSelectedIndemnite] = useState(null);
  const [quantiteIndemnite, setQuantiteIndemnite] = useState('');
  const [montantIndemnite, setMontantIndemnite] = useState('');
  const [editingPrimeId, setEditingPrimeId] = useState(null);
  const [editingIndemniteId, setEditingIndemniteId] = useState(null);
  const [selectedHeure, setSelectedHeure] = useState(null);
  const [quantiteHeure, setQuantiteHeure] = useState('');
  const [editingHeureId, setEditingHeureId] = useState(null);
  const [isPdfExporting, setIsPdfExporting] = useState(false);
  const [isLocked, setIsLocked] = useState(false); // verrouillage après enregistrement
  const [modificationRequested, setModificationRequested] = useState(false); // demande en attente
  const [modificationApproved, setModificationApproved] = useState(false); // validé par l'agence (via API plus tard)
  const [skipReload, setSkipReload] = useState(false); // Pour éviter le rechargement après sauvegarde




  const handleSave = async () => {
    console.log('🔵 handleSave appelé');
    console.log('📋 timeSheet:', timeSheet);
    console.log('🆔 timeSheet.id:', timeSheet?.id);
    console.log('💬 clientComment:', clientComment);
    console.log('⭐ clientRating:', clientRating);
    console.log('📝 clientRatingComment:', clientRatingComment);

    if (!timeSheet || !timeSheet.id) {
      console.error('❌ Pas de timeSheet ou pas d\'ID');
      toast.error("Aucun relevé d'heures chargé");
      return;
    }

    try {
      // Empêcher le rechargement automatique après la sauvegarde
      setSkipReload(true);
      console.log('⏳ Début de l\'enregistrement...');

      // Transformer les données du frontend au format backend
      const backendData = transformFrontendData(timeSheet);
      console.log('📦 Données transformées:', backendData);
      console.log('📦 CommentaireClient dans backendData:', backendData.CommentaireClient);

      // Mettre à jour le relevé d'heures (sans validation stricte)
      console.log('🚀 Envoi vers le backend avec ID:', timeSheet.id);
      const response = await releveHeuresService.update(timeSheet.id, backendData);
      console.log('✅ Réponse du backend:', response);
      console.log('✅ CommentaireClient dans la réponse:', response.CommentaireClient);

      toast.success("✅ Relevé enregistré avec succès ! Vous pouvez continuer à le modifier.");
      // Ne pas verrouiller les champs après l'enregistrement
      // L'utilisateur peut continuer à modifier
    } catch (error) {
      console.error('❌ Erreur lors de l\'enregistrement:', error);
      console.error('❌ Détails de l\'erreur:', error.response?.data || error.message);
      toast.error("❌ Erreur lors de l'enregistrement du relevé");
    } finally {
      // Réactiver le rechargement après un court délai
      setTimeout(() => setSkipReload(false), 1000);
      console.log('🏁 Fin de l\'enregistrement');
    }
  };

  // Fonction pour transformer les données du frontend au format backend
  const transformFrontendData = (frontendData) => {
    const TabJours = [];

    // Transformer les objets hours, nightHours et absences en TabJours
    const jours = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
    jours.forEach((jour, index) => {
      TabJours.push({
        NumeroJour: String(index + 1),
        NomJour: jour.charAt(0).toUpperCase() + jour.slice(1),
        DateJour: "", // À calculer selon la semaine
        NbHeureJour: frontendData.hours[jour] || "0",
        NbHeureNuit: frontendData.nightHours[jour] || "0",
        Chantier: frontendData.projectNumber || "",
        IdMotifAbsence: "",
        TxtMotifAbsence: frontendData.absences[jour] || ""
      });
    });

    // Transformer les heures diverses
    const TabHeures = heures.map(heure => ({
      TypeHeure: heure.type,
      Quantite: String(heure.quantite)
    }));

    // Transformer les primes
    const TabPrimes = primes.map(prime => ({
      TypePrime: prime.type,
      Montant: String(prime.montant),
      Quantite: String(prime.quantite)
    }));

    // Transformer les indemnités
    const TabIndemnites = indemnites.map(indemnite => ({
      TypeIndemnite: indemnite.type,
      Montant: String(indemnite.montant),
      Quantite: String(indemnite.quantite)
    }));

    return {
      TabJours,
      TabHeures,
      TabPrimes,
      TabIndemnites,
      FinDeMission: frontendData.endOfMission ? "1" : "0",
      NumeroContrat: frontendData.projectNumber || "",
      CommentaireClient: clientComment || "",
      NoteClient: String(clientRating),
      CommentaireEvaluation: clientRatingComment || "",
      status: frontendData.status
    };
  };

  const handleModificationRequest = () => {
  // Appel API fictif ou action simulée
  // Exemple : await sendModificationRequestToAgency(timeSheetId);
    setModificationRequested(true);
    alert("Votre demande de modification a été envoyée. Veuillez attendre la validation de l'agence.");
};

  // Exemple à appeler quand tu reçois une réponse positive
  const approveModification = () => {
    setModificationApproved(true);
    setIsLocked(false); // On débloque les champs
};


  const handleAddHeure = () => {
  if (selectedHeure && quantiteHeure) {
    setHeures(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedHeure.label,
        quantite: parseFloat(quantiteHeure),
      }
    ]);
    setSelectedPrime(null);
    setQuantiteHeure('');
  }
};
  
  const handleAddPrime = () => {
  if (selectedPrime && montantPrime && quantitePrime) {
    setPrimes(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedPrime.label,
        montant: parseFloat(montantPrime),
        quantite: parseFloat(quantitePrime),
      }
    ]);
    setSelectedPrime(null);
    setMontantPrime('');
    setQuantitePrime('');
  }
};


const handleAddIndemnite = () => {
  if (selectedIndemnite && montantIndemnite && quantiteIndemnite) {
    setIndemnites(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedIndemnite.label,
        montant: parseFloat(montantIndemnite),
        quantite: parseFloat(quantiteIndemnite),
      }
    ]);
    setSelectedIndemnite(null);
    setMontantIndemnite('');
    setQuantiteIndemnite('');
  }
};

const handleDeleteHeure = (id) => {
  setHeures(prev => prev.filter(p => p.id !== id));
};

const handleDeletePrime = (id) => {
  setPrimes(prev => prev.filter(p => p.id !== id));
};

const handleDeleteIndemnite = (id) => {
  setIndemnites(prev => prev.filter(i => i.id !== id));
};

const handleUpdateHeure = () => {
  const updatedRows = heures.map(row =>
    row.id === editingHeureId
      ? {
          ...row,
          type: selectedHeure.label,
          quantite: parseFloat(quantiteHeure)
        }
      : row
  );
  setHeures(updatedRows);
  setEditingHeureId(null);
  setSelectedHeure(null);
  setQuantiteHeure('');
};

const handleUpdatePrime = () => {
  const updatedRows = primes.map(row =>
    row.id === editingPrimeId
      ? {
          ...row,
          type: selectedPrime.label,
          montant: parseFloat(montantPrime),
          quantite: parseFloat(quantitePrime)
        }
      : row
  );
  setPrimes(updatedRows);
  setEditingPrimeId(null);
  setSelectedPrime(null);
  setMontantPrime('');
  setQuantitePrime('');
};

const handleUpdateIndemnite = () => {
  const updatedRows = indemnites.map(row =>
    row.id === editingIndemniteId
      ? {
          ...row,
          type: selectedIndemnite.label,
          montant: parseFloat(montantIndemnite),
          quantite: parseFloat(quantiteIndemnite)
        }
      : row
  );
  setIndemnites(updatedRows);
  setEditingIndemniteId(null);
  setSelectedIndemnite(null);
  setMontantIndemnite('');
  setQuantiteIndemnite('');
};

const startEditHeure = (row) => {
  setEditingHeureId(row.id);
  setSelectedHeure({ label: row.type });
  setQuantiteHeure(row.quantite); 
};


const startEditPrime = (row) => {
  setEditingPrimeId(row.id);
  setSelectedPrime({ label: row.type });
  setMontantPrime(row.montant);
  setQuantitePrime(row.quantite); 
};

const startEditIndemnite = (row) => {
  setEditingIndemniteId(row.id);
  setSelectedIndemnite({ label: row.type });
  setMontantIndemnite(row.montant);
  setQuantiteIndemnite(row.quantite);
};




  // Récupérer l'ID du relevé d'heures depuis l'URL ou charger les relevés du client
  useEffect(() => {
    console.log('🔄 useEffect déclenché - location.search:', location.search);
    console.log('🔄 location.state:', location.state);
    console.log('🔄 skipReload:', skipReload);
    console.log('🔄 timeSheet actuel:', timeSheet?.id);
    console.log('🔄 isOverlay:', isOverlay);
    console.log('🔄 timesheetId (prop):', timesheetId);

    // Ne pas recharger si on vient de sauvegarder
    if (skipReload) {
      console.log('⏭️ Rechargement ignoré (sauvegarde en cours)');
      return;
    }

    // Si en mode overlay, utiliser les props
    if (isOverlay && initialTimesheet) {
      console.log('📦 Mode overlay - Données reçues via props');
      const transformedData = transformBackendData(initialTimesheet);
      setTimeSheet(transformedData);
      return;
    }

    // Si en mode overlay avec juste l'ID
    if (isOverlay && timesheetId) {
      console.log('📥 Mode overlay - Chargement avec ID:', timesheetId);
      loadTimeSheet(timesheetId);
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const urlTimesheetId = searchParams.get('id');

    // Si les données sont passées via state (navigation depuis la liste)
    if (location.state?.timesheet) {
      console.log('📦 Données reçues via state, pas d\'appel API');
      const transformedData = transformBackendData(location.state.timesheet);
      setTimeSheet(transformedData);
      return;
    }

    // Sinon, charger depuis l'API uniquement si nécessaire
    if (urlTimesheetId) {
      if (timeSheet?.id !== urlTimesheetId) {
        console.log('📥 Chargement du relevé avec ID:', urlTimesheetId);
        loadTimeSheet(urlTimesheetId);
      } else {
        console.log('⏭️ Relevé déjà chargé, pas besoin de recharger');
      }
    } else {
      if (!timeSheet) {
        console.log('📥 Chargement du premier relevé disponible');
        // Si pas d'ID, charger le premier relevé disponible pour le client
        loadFirstAvailableTimeSheet();
      }
    }
  }, [location.search, location.state, isOverlay, timesheetId, initialTimesheet]);

  // Fonction pour charger le premier relevé disponible
  const loadFirstAvailableTimeSheet = async () => {
    try {
      setIsLoading(true);
      const timesheets = await releveHeuresService.getAllForClient();

      if (timesheets && timesheets.length > 0) {
        // Prendre le premier relevé
        const transformedData = transformBackendData(timesheets[0]);
        setTimeSheet(transformedData);
        toast.success('Relevé d\'heures chargé avec succès');
      } else {
        // Aucun relevé disponible, utiliser les données mock
        setTimeSheet(mockTimeSheet);
        toast.info('Aucun relevé d\'heures disponible');
      }
    } catch (error) {
      console.error('Erreur lors du chargement des relevés:', error);
      // En cas d'erreur, utiliser les données mock
      setTimeSheet(mockTimeSheet);
      toast.error('Erreur lors du chargement des relevés d\'heures');
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour charger un relevé d'heures depuis l'API
  const loadTimeSheet = async (id) => {
    try {
      setIsLoading(true);
      console.log('📥 loadTimeSheet - Chargement du relevé ID:', id);
      const data = await releveHeuresService.getById(id);

      // Transformer les données du backend au format attendu par le frontend
      const transformedData = transformBackendData(data);
      setTimeSheet(transformedData);

      console.log('✅ loadTimeSheet - Relevé chargé avec succès');
      // Ne pas afficher de toast ici pour éviter la confusion avec le toast de sauvegarde
    } catch (error) {
      console.error('Erreur lors du chargement du relevé:', error);
      toast.error('Erreur lors du chargement du relevé d\'heures');
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour transformer les données du backend au format frontend
  const transformBackendData = (backendData) => {
    const hours = {};
    const nightHours = {};
    const absences = {};

    // Transformer TabJours en objets hours, nightHours et absences
    if (backendData.TabJours && Array.isArray(backendData.TabJours)) {
      backendData.TabJours.forEach(jour => {
        // Vérifier que NomJour existe avant de l'utiliser
        if (!jour.NomJour) {
          console.warn('Jour sans NomJour:', jour);
          return;
        }

        const dayKey = jour.NomJour.toLowerCase();
        hours[dayKey] = jour.NbHeureJour || "";
        nightHours[dayKey] = jour.NbHeureNuit || "";
        absences[dayKey] = jour.TxtMotifAbsence || "";
      });
    }

    // Charger les heures diverses depuis le backend
    if (backendData.TabHeures && Array.isArray(backendData.TabHeures)) {
      const heuresFromBackend = backendData.TabHeures.map((heure, index) => ({
        id: Date.now() + index,
        type: heure.TypeHeure || "",
        quantite: parseFloat(heure.Quantite) || 0
      }));
      setHeures(heuresFromBackend);
    }

    // Charger les primes depuis le backend
    if (backendData.TabPrimes && Array.isArray(backendData.TabPrimes)) {
      const primesFromBackend = backendData.TabPrimes.map((prime, index) => ({
        id: Date.now() + index + 1000,
        type: prime.TypePrime || "",
        montant: parseFloat(prime.Montant) || 0,
        quantite: parseFloat(prime.Quantite) || 0
      }));
      setPrimes(primesFromBackend);
    }

    // Charger les indemnités depuis le backend
    if (backendData.TabIndemnites && Array.isArray(backendData.TabIndemnites)) {
      const indemnitesFromBackend = backendData.TabIndemnites.map((indemnite, index) => ({
        id: Date.now() + index + 2000,
        type: indemnite.TypeIndemnite || "",
        montant: parseFloat(indemnite.Montant) || 0,
        quantite: parseFloat(indemnite.Quantite) || 0
      }));
      setIndemnites(indemnitesFromBackend);
    }

    // Charger les commentaires et évaluation
    if (backendData.CommentaireClient) {
      setClientComment(backendData.CommentaireClient);
    }
    if (backendData.NoteClient) {
      setClientRating(parseInt(backendData.NoteClient) || 0);
    }
    if (backendData.CommentaireEvaluation) {
      setClientRatingComment(backendData.CommentaireEvaluation);
    }

    // Parser les dates du backend (format YYYYMMDD)
    const startDateObj = parseBackendDate(backendData.DateDebut);
    const endDateObj = parseBackendDate(backendData.DateFin);

    return {
      id: backendData._id,
      weekNumber: startDateObj ? getWeekNumber(startDateObj) : 0,
      year: startDateObj ? startDateObj.getFullYear() : new Date().getFullYear(),
      startDate: formatDate(backendData.DateDebut),
      endDate: formatDate(backendData.DateFin),
      employeeName: backendData.NomPrenom || "",
      employeePosition: backendData.Profession || "",
      employeeCompany: backendData.RaisonSociale || "",
      employeeId: backendData.IdInterimaire || "",
      hours,
      nightHours,
      absences,
      status: backendData.status || "pending",
      clientComment: backendData.CommentaireClient || "",
      employeeComment: "",
      projectNumber: backendData.NumeroContrat || "",
      endOfMission: backendData.FinDeMission === "1",
      clientRating: parseInt(backendData.NoteClient) || 0,
      clientRatingComment: backendData.CommentaireEvaluation || ""
    };
  };

  // Fonction helper pour obtenir le numéro de semaine
  const getWeekNumber = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  };

  // Fonction helper pour parser les dates au format YYYYMMDD
  const parseBackendDate = (dateString) => {
    if (!dateString) return null;
    // Format: "20251110" -> YYYYMMDD
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6)) - 1; // Les mois commencent à 0
    const day = parseInt(dateString.substring(6, 8));
    return new Date(year, month, day);
  };

  // Fonction helper pour formater les dates
  const formatDate = (dateString) => {
    if (!dateString) return "";

    // Si c'est au format YYYYMMDD (string de 8 caractères)
    if (typeof dateString === 'string' && dateString.length === 8) {
      const date = parseBackendDate(dateString);
      if (!date || isNaN(date.getTime())) return "";
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    // Sinon, essayer de parser comme une date normale
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Fonction pour mettre à jour les heures
  const updateHours = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [day]: value
      }
    }));
  };
  
  // Fonction pour mettre à jour les heures de nuit
  const updateNightHours = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      nightHours: {
        ...prev.nightHours,
        [day]: value
      }
    }));
  };
  
  // Fonction pour mettre à jour les motifs d'absence
  const updateAbsence = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      absences: {
        ...prev.absences,
        [day]: value
      }
    }));
  };
  
  // Fonction pour calculer le total des heures
  const calculateTotalHours = () => {
    if (!timeSheet) return 0;

    let total = 0;

    // Somme des heures de jour
    Object.values(timeSheet.hours).forEach(hours => {
      if (hours) {
        // Ignorer complètement les valeurs texte (pendant la saisie)
        if (typeof hours === 'string') {
          return; // Ne rien faire si c'est du texte
        }
        // Seulement compter les nombres
        const numValue = parseFloat(hours);
        if (!isNaN(numValue)) {
          total += numValue;
        }
      }
    });

    // Ajout des heures de nuit si nécessaire
    if (nightHoursOption === "additional") {
      Object.values(timeSheet.nightHours).forEach(hours => {
        if (hours) {
          // Ignorer complètement les valeurs texte (pendant la saisie)
          if (typeof hours === 'string') {
            return; // Ne rien faire si c'est du texte
          }
          // Seulement compter les nombres
          const numValue = parseFloat(hours);
          if (!isNaN(numValue)) {
            total += numValue;
          }
        }
      });
    }

    return total;
  };
  
  // Calcul des heures supplémentaires (au-delà de l'horaire sélectionné)
const calculateOvertimeHours = () => {
  const total = calculateTotalHours();

  // Extraire le nombre d'heures depuis le string "31h", "33h", etc.
  const baseHours = parseInt(weekHoursOption?.replace("h", "")) || 35;

  return total > baseHours ? total - baseHours : 0;
};

  // Formatage des heures selon le mode sélectionné
  const formatHours = (hours) => {
  if (!hours && hours !== 0) return "";

  // Si c'est déjà une chaîne (pendant la saisie)
  if (typeof hours === 'string') {
    // En mode centièmes, afficher tel quel pendant la saisie
    if (hourFormat === "centiemes") {
      return hours;
    }
    // En mode minutes, afficher tel quel pendant la saisie
    return hours;
  }

  const hoursValue = parseFloat(hours);
  if (isNaN(hoursValue)) return "";

  if (hourFormat === "centiemes") {
    return hoursValue.toFixed(2).replace(".", ",");
  } else if (hourFormat === "minutes") {
    const hoursInt = Math.floor(hoursValue);
    const minutesDecimal = (hoursValue - hoursInt) * 60;
    const minutes = Math.round(minutesDecimal);
    return `${hoursInt.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  } else {
    return hoursValue.toString();
  }
};


  // Fonction pour naviguer entre les semaines
  const navigateWeek = async (direction) => {
    try {
      setIsLoading(true);

      // Calculer les dates de la nouvelle semaine
      const currentStartDate = new Date(timeSheet.startDate.split('/').reverse().join('-'));
      const daysToAdd = direction === "prev" ? -7 : 7;
      const newStartDate = new Date(currentStartDate);
      newStartDate.setDate(currentStartDate.getDate() + daysToAdd);

      const newEndDate = new Date(newStartDate);
      newEndDate.setDate(newStartDate.getDate() + 6);

      // Charger les relevés de la nouvelle semaine
      const weekTimesheets = await releveHeuresService.getByWeek(newStartDate, newEndDate);

      if (weekTimesheets && weekTimesheets.length > 0) {
        // Prendre le premier relevé de la semaine
        const transformedData = transformBackendData(weekTimesheets[0]);
        setTimeSheet(transformedData);
        toast.success('Semaine chargée avec succès');
      } else {
        // Aucun relevé pour cette semaine
        toast.info('Aucun relevé d\'heures pour cette semaine');

        // Mettre à jour juste les dates et le numéro de semaine
        setTimeSheet(prev => ({
          ...prev,
          weekNumber: direction === "prev" ? prev.weekNumber - 1 : prev.weekNumber + 1,
          startDate: formatDate(newStartDate),
          endDate: formatDate(newEndDate)
        }));
      }
    } catch (error) {
      console.error('Erreur lors de la navigation:', error);
      toast.error('Erreur lors du chargement de la semaine');
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour soumettre le relevé d'heures - Envoyer vers Tempo
  const submitTimeSheet = () => {
    // Dans un cas réel, envoyer les données au serveur
    setTimeSheet(prev => ({
      ...prev,
      status: "integrated"
    }));
    alert("Relevé d'heures envoyé vers Tempo");
  };
  
  // Fonction pour envoyer vers l'agence
  const sendToAgency = async () => {
    if (!validerAvantEnregistrement()) {
      return;
    }

    try {
      // Empêcher le rechargement automatique après l'envoi
      setSkipReload(true);

      // Transformer les données et mettre à jour le statut
      const backendData = {
        ...transformFrontendData(timeSheet),
        status: "a_valider" // En attente de validation de l'agence
      };

      // Mettre à jour le relevé avec le nouveau statut
      await releveHeuresService.update(timeSheet.id, backendData);

      setTimeSheet(prev => ({
        ...prev,
        status: "a_valider"
      }));

      toast.success("Relevé d'heures envoyé vers l'agence avec succès ! En attente de validation.");
      setIsLocked(true);
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
      toast.error("Erreur lors de l'envoi du relevé vers l'agence");
    } finally {
      // Réactiver le rechargement après un court délai
      setTimeout(() => setSkipReload(false), 1000);
    }
  };
  
  // Fonction pour annuler le contrat
  const cancelContract = () => {
    setTimeSheet(prev => ({
      ...prev,
      status: "canceled",
    }));
    alert("Contrat annulé");
  };

  // Fonction pour télécharger le relevé
  const downloadTimeSheet = () => {
  setIsPdfExporting(true);

  setTimeout(() => {
  const input = document.getElementById("pdf-content");
  const Name = timeSheet.employeeName.trim() || "releve";
    
  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 20;

    const title = `Relevé d'heures de ${Name}`;
    pdf.setFont("helvetica", "bold"); // police en gras
    pdf.setFontSize(16);

    const textWidth = pdf.getTextWidth(title);
    const xCentered = (pageWidth - textWidth) / 2;

    pdf.text(title, xCentered, 15);

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= (pageHeight - position);

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const safeName = Name.replace(/\s+/g, "_"); // remplace les espaces par des underscores
    const fileName = `releve_heures_${safeName}.pdf`;
    console.log("Nom du fichier sécurisé :", fileName);
    pdf.save(fileName);
    setIsPdfExporting(false); // on repasse en mode normal
  });
}, 100); 
  };
  
  // Fonction pour obtenir le libellé du statut en français
  const getStatusLabel = (status) => {
    switch(status) {
      case "pending":
        return "En attente";
      case "a_saisir":
        return "À saisir";
      case "a_valider":
        return "En attente de validation";
      case "approved":
        return "Approuvé";
      case "rejected":
        return "Rejeté";
      case "canceled":
        return "Annulé";
      case "to_integrate":
        return "À intégrer";
      case "integrated":
        return "Intégré";
      default:
        return "Inconnu";
    }
  };

  // Fonction pour obtenir la classe CSS selon le statut
  const getStatusClass = (status)=> {
    switch(status) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "a_saisir":
        return "bg-orange-100 text-orange-800";
      case "a_valider":
        return "bg-blue-100 text-blue-800";
      case "approved":
        return "bg-green-100 text-green-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      case "canceled":
        return "bg-red-100 text-red-800";
      case "to_integrate":
        return "bg-indigo-100 text-indigo-800";
      case "integrated":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Fonction pour déterminer si un jour est travaillé (lundi à vendredi)
  const isWorkingDay = (dayKey) => {
    const nonWorkingDays = ['samedi', 'dimanche'];
    return !nonWorkingDays.includes(dayKey);
  };

  // Fonction pour formater automatiquement les heures en HH:MM
  // Fonction pour formater l'input au blur (quand on quitte le champ)
  const formatTimeInput = (value) => {
    if (!value || value.trim() === '') return '';

    // Si déjà au format HH:MM, on valide juste
    if (value.includes(':')) {
      const parts = value.split(':');
      let h = parseInt(parts[0]) || 0;
      let m = parseInt(parts[1]) || 0;

      if (h > 23) h = 23;
      if (m > 59) m = 59;

      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    }

    // Supprimer tout sauf les chiffres
    const digits = value.replace(/\D/g, '');
    if (!digits) return '';

    // Selon le nombre de chiffres
    if (digits.length === 1) {
      // 1 chiffre : ex "8" → "08:00"
      return `${digits.padStart(2, '0')}:00`;
    } else if (digits.length === 2) {
      // 2 chiffres : ex "21" → "21:00"
      let h = parseInt(digits);
      if (h > 23) h = 23;
      return `${String(h).padStart(2, '0')}:00`;
    } else if (digits.length === 3) {
      // 3 chiffres : ex "830" → "08:30"
      let h = parseInt(digits.substring(0, 1));
      let m = parseInt(digits.substring(1, 3));
      if (m > 59) m = 59;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    } else {
      // 4 chiffres ou plus : ex "2356" → "23:56"
      let h = parseInt(digits.substring(0, 2));
      let m = parseInt(digits.substring(2, 4));
      if (h > 23) h = 23;
      if (m > 59) m = 59;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    }
  };

  // Fonction pour valider les heures (max 23:59)
  const validateHours = (value) => {
    if (!value || value === '') return '';

    // Si le format est HH:MM
    if (value.includes(':')) {
      const [hours, minutes] = value.split(':');
      const h = parseInt(hours) || 0;
      const m = parseInt(minutes) || 0;

      // Limiter à 23:59
      if (h > 23) return '23:59';
      if (h === 23 && m > 59) return '23:59';
      if (m > 59) return `${h}:59`;

      return value;
    }

    // Si le format est décimal
    const numValue = parseFloat(value.replace(',', '.'));
    if (isNaN(numValue)) return '';

    // Limiter à 23.99 (23h59)
    if (numValue > 23.99) {
      toast.warning("Les heures ne peuvent pas dépasser 23:59");
      return '23.99';
    }

    return value;
  };

  // Gérer le changement d'heures (onChange - RIEN de spécial, juste stocker)
  const handleHourChange = (dayKey, value) => {
    // On stocke directement la valeur dans le state
    // Le formatage se fera au blur
    setTimeSheet(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [dayKey]: value // Stocker la valeur brute (texte)
      }
    }));
  };

  // Formater les heures au blur (quand l'utilisateur quitte le champ)
  const handleHourBlur = (dayKey, value) => {
    if (!value || value === '') {
      updateHours(dayKey, 0);
      return;
    }

    // Formater la valeur en HH:MM
    const formattedValue = formatTimeInput(value);

    // Convertir en nombre décimal pour le backend
    let numericValue = 0;
    if (formattedValue.includes(':')) {
      const [hours, minutes] = formattedValue.split(':');
      numericValue = parseFloat(hours) + (parseFloat(minutes || 0) / 60);
    }

    // Mettre à jour avec la valeur numérique
    updateHours(dayKey, numericValue);
  };

  // Gérer le changement d'heures de nuit (onChange - RIEN de spécial, juste stocker)
  const handleNightHourChange = (dayKey, value) => {
    // On stocke directement la valeur dans le state
    setTimeSheet(prev => ({
      ...prev,
      nightHours: {
        ...prev.nightHours,
        [dayKey]: value // Stocker la valeur brute (texte)
      }
    }));
  };

  // Formater les heures de nuit au blur
  const handleNightHourBlur = (dayKey, value) => {
    if (!value || value === '') {
      updateNightHours(dayKey, 0);
      return;
    }

    const formattedValue = formatTimeInput(value);

    let numericValue = 0;
    if (formattedValue.includes(':')) {
      const [hours, minutes] = formattedValue.split(':');
      numericValue = parseFloat(hours) + (parseFloat(minutes || 0) / 60);
    }

    updateNightHours(dayKey, numericValue);
  };


  const validerAvantEnregistrement = () => {
  if (!timeSheet) {
    toast.error("Aucun relevé d'heures chargé");
    return false;
  }

  const totalHeures = calculateTotalHours();

  // Conversion de weekHoursOption "35h" en nombre 35
  const modulationSemaine = parseInt(weekHoursOption);

  // Vérifie qu'au moins une heure est renseignée
  const heuresValides = totalHeures > 0;

  // Absences obligatoires si totalHeures < modulationSemaine
  let absencesRenseignees = true;
  if (totalHeures < modulationSemaine) {
    absencesRenseignees = Object.values(timeSheet.absences).some((val) => val && val.trim() !== "");
  }
  // Vérifie que "Fin de mission" est défini (true ou false)
  const finDeMissionRenseignee = typeof timeSheet.endOfMission === "boolean";

  // Si évaluation < 3, le commentaire devient obligatoire
  const commentaireObligatoire = clientRating >= 3 || (clientRating < 3 && clientRatingComment.trim() !== "");

  if (!heuresValides) {
    toast.error("Veuillez renseigner au moins une heure dans la semaine.");
    return false;
  }

  if (totalHeures < modulationSemaine && !absencesRenseignees) {
    toast.error("Veuillez renseigner au moins un motif d'absence pour compenser les heures manquantes.");
    return false;
  }


   if (!finDeMissionRenseignee) {
    toast.error("Veuillez indiquer si c'est la fin de mission.");
    return false;
  }

  if (!commentaireObligatoire) {
    toast.error("Veuillez ajouter un commentaire si la note est inférieure à 3 étoiles.");
    return false;
  }

  return true;
};


  // Afficher un loader pendant le chargement
  if (isLoading || !timeSheet) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-slate-600">Chargement du relevé d'heures...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="container mx-auto py-8 px-4">
        {/* En-tête moderne */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-lg">
                <Clock size={32} className="text-white" />
              </div>
              <div>
                <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                  Relevé d'Heures
                </h1>
                <p className="text-slate-600 mt-1">
                  Semaine {timeSheet.weekNumber} • {timeSheet.startDate} - {timeSheet.endDate}
                </p>
              </div>
            </div>

            {!isOverlay && (
              <button
                onClick={() => navigate("/relevesdheures")}
                className="inline-flex items-center px-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm text-sm font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                <ArrowLeft size={20} className="mr-2" />
                Retour à la liste
              </button>
            )}
          </div>
        </div>

        <main id="pdf-content" className="flex-grow">

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <>


        {/* Navigation semaine */}
        {/* <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigateWeek("prev")}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-600"
              >
                <ChevronLeft size={24} />
              </button>

              <h2 className="text-xl font-semibold text-slate-800">SEMAINE {timeSheet.weekNumber}</h2>

              <button
                onClick={() => navigateWeek("next")}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors text-slate-600"
              >
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
        </div> */}
        
        {/* Information de saisie et statut */}
        <div className="bg-slate-50 p-4 flex items-center justify-between rounded-xl border border-slate-200 mb-6 text-sm text-slate-600 shadow-sm">

            <div className="flex items-center justify-between w-full gap-3">
                {isPdfExporting ? (
                  <p><strong>Fin de mission :</strong> {timeSheet.endOfMission ? "Oui" : "Non"}</p>
                ) : (
                  <div className="flex items-center gap-2">
                    <label htmlFor="endOfMission" className="font-medium text-slate-700 mb-1 block">
                      Fin de mission :
                    </label>
                    <select
                      id="endOfMission"
                      value={timeSheet.endOfMission ? "oui" : "non"}
                      disabled={isLocked && !modificationApproved}
                      onChange={(e) =>
                      setTimeSheet((prev) => ({
                      ...prev,
                      endOfMission: e.target.value === "oui",
                    }))
                    }
                    className="px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="non">Non</option>
                    <option value="oui">Oui</option>
                    </select>
                    </div>
                    )}

                  </div>

            <div className="flex items-center space-x-2 w-96 justify-end">
                <label className="font-medium text-slate-700">ID:</label>
                <span className="px-2 py-1 text-xs bg-gray-100 rounded">
                  {timeSheet.id || "Aucun ID"}
                </span>
                <label className="font-medium text-slate-700">Statut:</label>
                <span className={`px-3 py-1 text-xs font-semibold rounded-lg ${getStatusClass(timeSheet.status)}`}>
                  {getStatusLabel(timeSheet.status)}
                </span>
              </div>
        </div>

        {/* Options et format des heures */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
            <h3 className="text-sm font-medium text-slate-700 mb-3">Format d'heures</h3>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800">
                {hourFormat === "centiemes" ? "Centièmes" : "Minutes"}
              </p>
              ) : (
              <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setHourFormat("minutes")}
                className={`px-3 py-2 text-sm border rounded-lg transition-all ${hourFormat === "minutes" ? 'bg-blue-100 border-blue-500 text-blue-700' : 'border-slate-300 text-slate-700 hover:bg-slate-50'}`}
              >
                Minutes
              </button>
              <button
                onClick={() => setHourFormat("centiemes")}
                className={`px-3 py-2 text-sm border rounded-lg transition-all ${hourFormat === "centiemes" ? 'bg-blue-100 border-blue-500 text-blue-700' : 'border-slate-300 text-slate-700 hover:bg-slate-50'}`}
              >
                Centièmes
              </button>
            </div>
            )}
          </div>

          <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
           <h3 className="text-sm font-medium text-slate-700 mb-3">Heures de nuit incluses</h3>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800">
              {nightHoursOption === "included" ? "Avec heures de nuit" : "Sans heures de nuit"}
              </p>
            ) : (
              <div className="flex gap-2">
              <button
                onClick={() => setNightHoursOption("included")}
                className={`px-3 py-2 text-sm border rounded-lg transition-all ${nightHoursOption === "included" ? 'bg-blue-100 border-blue-500 text-blue-700' : 'border-slate-300 text-slate-700 hover:bg-slate-50'}`}
              >
                Oui
              </button>
              <button
                onClick={() => setNightHoursOption("additional")}
                className={`px-3 py-2 text-sm border rounded-lg transition-all ${nightHoursOption === "additional" ? 'bg-blue-100 border-blue-500 text-blue-700' : 'border-slate-300 text-slate-700 hover:bg-slate-50'}`}
              >
                Non
              </button>
            </div>
            )}
          </div>

          <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
            <h3 className="text-sm font-medium text-slate-700 mb-3">Modulation semaine</h3>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800">{weekHoursOption}</p>
            ) : (
            <div className="flex gap-2">
             {["31h", "33h", "35h", "37h", "39h"].map((hour) => (
              <button
                key={hour}
                onClick={() => setweekHoursOption(hour)}
                className={`px-3 py-2 text-sm border rounded-lg transition-all ${
                weekHoursOption === hour
                ? "bg-blue-100 border-blue-500 text-blue-700"
                : "border-slate-300 text-slate-700 hover:bg-slate-50"
              }`}
              >
              {hour}
              </button>
             ))}
            </div>
            )}
          </div>

          <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm">
            <h3 className="text-sm font-medium text-slate-700 mb-3">Chantier / Service</h3>
            {isPdfExporting ? (
              <p className="text-sm font-medium text-slate-800">{timeSheet.projectNumber}</p>
            ) : (
              <input
                type="text"
                disabled={isLocked && !modificationApproved}
                value={timeSheet.projectNumber || ""}
                onChange={(e) => setTimeSheet(prev => ({ ...prev, projectNumber: e.target.value }))}
                className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="N° chantier ou service"
              />
            )}
          </div>
        </div>

        {/* Relevé d'heures */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
          {/* Période */}
          <div className="text-center mb-4">
            <p className="text-slate-600">{timeSheet.startDate} - {timeSheet.endDate}</p>
          </div>

          {/* Informations employé */}
          <div className="flex items-center mb-6">
            <div className="h-12 w-12 rounded-full bg-blue-50 border-2 border-blue-400 flex items-center justify-center text-slate-700 font-bold mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div>
              <p className="font-bold text-slate-800">{timeSheet.employeeName}</p>
              <p className="text-sm font-medium text-slate-700">{timeSheet.employeePosition}</p>
              <p className="text-sm text-slate-600">
                {timeSheet.employeeCompany}
                <span className="ml-2 text-slate-400">{timeSheet.employeeId}</span>
              </p>
            </div>
          </div>
          

          <div className="grid grid-cols-8 gap-3 min-w-max">
            {/* Ligne 1 — En-tête vide + noms des jours */}
            <div></div>
              {weekDays.map((day) => (
              <div key={`head-${day.key}`} className="text-center">
                <p className="font-medium text-slate-800">{day.name}</p>
                <p className="text-sm text-slate-600">{day.date}</p>
              </div>
              ))}

            {/* Ligne 2 — Icône jour + inputs jour */}
            <div className="flex items-center justify-center">
              <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center text-amber-600">
              {/* soleil */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            {weekDays.map((day, index) => (
              <div key={`day-${day.key}`} className="flex justify-center">
                   {isPdfExporting ? (
                <div className="w-16 h-10 text-center text-sm flex items-center justify-center text-slate-800">
                  {formatHours(timeSheet.hours[day.key]) || "-"}
                </div>
                  ) : (
                <input
                  type="text"
                  disabled={!isWorkingDay(day.key) || (isLocked && !modificationApproved)}
                  value={formatHours(timeSheet.hours[day.key])}
                  onFocus={(e) => {
                    // Sélectionner tout le texte au focus
                    e.target.select();
                  }}
                  onChange={(e) => {
                    handleHourChange(day.key, e.target.value);
                  }}
                  onBlur={(e) => {
                    handleHourBlur(day.key, e.target.value);
                  }}
                  placeholder={!isWorkingDay(day.key) ? "-" : ""}
                  className={`w-16 h-10 text-sm text-center border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isWorkingDay(day.key) ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : ''}`}
                />

                )}
             </div>
            ))}

            {/* Ligne 3 — Icône nuit + inputs nuit */}
            <div className="flex items-center justify-center">
              <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                {/* lune */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              </div>
            </div>
            {weekDays.map((day, index) => (
              <div key={`night-${day.key}`} className="flex justify-center">
                {isPdfExporting ? (
                <div className="w-16 h-10 text-center text-sm flex items-center justify-center text-slate-800">
                  {formatHours(timeSheet.nightHours[day.key]) || "-"}
                </div>
                ) : (
                <input
                  type="text"
                  disabled={!isWorkingDay(day.key) || (isLocked && !modificationApproved)}
                  value={formatHours(timeSheet.nightHours[day.key])}
                  onFocus={(e) => {
                    // Sélectionner tout le texte au focus
                    e.target.select();
                  }}
                  onChange={(e) => {
                    handleNightHourChange(day.key, e.target.value);
                  }}
                  onBlur={(e) => {
                    handleNightHourBlur(day.key, e.target.value);
                  }}
                  placeholder={!isWorkingDay(day.key) ? "-" : ""}
                  className={`w-16 h-10 text-sm text-center border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${!isWorkingDay(day.key) ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : ''}`}
                />

              )}
              </div>
            ))}
          </div>



          {/* Motifs d'absence */}
          <div className="overflow-x-auto mt-6">
            <div className="grid grid-cols-8 gap-3 min-w-max items-center">
              <div className="text-right pr-2 text-sm text-slate-700 font-medium">Motifs d'absence</div>

              {weekDays.map((day) => (
                <div key={`absence-${day.key}`} className="flex justify-center">
                  {isPdfExporting ? (
                   <div className="min-w-[80px] px-2 py-1 text-sm text-slate-800 text-center whitespace-pre-wrap">
                      {timeSheet.absences[day.key] || "-"}
                    </div>
                  ) : (
                  <select
                    value={timeSheet.absences[day.key]}
                    disabled={isLocked && !modificationApproved}
                    onChange={(e) => updateAbsence(day.key, e.target.value)}
                    className="w-full px-2 py-1 text-sm text-left border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">-</option>
                    <option value="AI">Absence injustifiée</option>
                    <option value="AJ">Absence justifiée</option>
                    <option value="ATR">Accident de trajet</option>
                    <option value="AT">Accident de travail</option>
                    <option value="CP">Congé payé</option>
                    <option value="M">Maladie</option>
                    <option value="R">Repos</option>
                    <option value="RTT">RTT</option>
                    <option value="AUTRE">Autre</option>

                  </select>
                  )}
                </div>
              ))}
            </div>
          </div>

          
          {/* Total des heures et bouton d'envoi */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mt-6 border-t border-gray-400 pt-4">
            <div className="mb-4 md:mb-0">
              <div className="flex flex-col">
                <div className="flex items-center mb-1">
                  <span className="font-medium text-slate-700 mr-2">Total de la semaine:</span>
                  <span className="text-lg font-bold text-slate-800">{calculateTotalHours().toFixed(1)}h</span>
                </div>

                {calculateOvertimeHours() > 0 && (
                  <div className="text-sm text-blue-600 font-medium">
                    dont {calculateOvertimeHours().toFixed(1)}h supplémentaires
                  </div>
                )}
              </div>
            </div>


          </div>
        </div>

         {/* Section heures */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
          <h3 className="text-2xl font-medium text-blue-600 mb-1">Heures diverses</h3>
          <p className="text-sm text-slate-500 mb-5">Ces heures seront facturées au même taux que les heures normales.</p>
          {!isPdfExporting && (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
            {/* Select Primes */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Heures</label>
              <Select
                value={selectedHeure}
                disabled={isLocked && !modificationApproved}
                onChange={(value) => { setSelectedHeure(value); }}
                options={heureOptions}
                placeholder="Sélectionner un type d'heure"
                className="text-sm"
              />
            </div>

            {/* Quantité */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Quantité</label>
              <input
                type="number"
                disabled={isLocked && !modificationApproved}
                min="0"
                value={quantiteHeure}
                onChange={(e) => setQuantiteHeure(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
              />
            </div>


            {/* Bouton Ajouter */}
            <div className="flex items-end">
             {editingHeureId ? (
              <button onClick={handleUpdateHeure} className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                >Enregistrer</button>
              ) : (
              <button onClick={handleAddHeure} className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >Ajouter
              </button>
              )}

            </div>
          </div>
          )}



          <div className="border border-slate-200 rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-slate-200">
              <thead className="bg-slate-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Type</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Quantité</th>
                  {!isPdfExporting && (
                  <th scope="col" className="px-6 py-3 text-xs font-medium text-slate-700 uppercase tracking-wider text-right">Actions</th>
                    )}
                </tr>
              </thead>
                <tbody className="bg-white divide-y divide-slate-100">
                  {heures.map((row) => (
                    <tr key={row.id} className="hover:bg-slate-50 transition-colors">
                      <td className="px-6 py-4 text-sm text-slate-700">{row.type}</td>
                      <td className="px-6 py-4 text-sm text-slate-700">{row.quantite}</td>
                      {!isPdfExporting && (
                      <td className="px-6 py-4 text-right">
                        <div className="flex items-center justify-end space-x-3">
                          <button
                            onClick={() => startEditHeure(row)}
                            className="relative group text-slate-600 hover:text-blue-600 transition-colors"
                          >
                            <Pencil size={18} />
                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-slate-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                            Modifier
                            </div>
                          </button>

                          <button
                            onClick={() => handleDeleteHeure(row.id)}
                            className="relative group text-slate-600 hover:text-red-600 transition-colors"
                          >
                            <Trash2 size={18} className="text-red-600 group-hover:text-red-700"/>
                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-slate-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                              Supprimer
                            </div>
                          </button>
                        </div>

                      </td>
                      )}
                    </tr>
                  ))}
                  {heures.length === 0 && (
                    <tr>
                      <td colSpan="5" className="px-6 py-4 text-center text-sm text-slate-500">
                        Aucun élément ajouté
                      </td>
                    </tr>
                  )}
                </tbody>

            </table>
          </div>
        </div>

        {/* Section primes */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
          <h3 className="text-2xl font-medium text-blue-600 mb-1">Primes</h3>
          <p className="text-sm text-slate-500 mb-5">Ces primes sont assujetties aux charges sociales.</p>
          {!isPdfExporting && (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
            {/* Select Primes */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Primes</label>
              <Select
                value={selectedPrime}
                disabled={isLocked && !modificationApproved}
                onChange={(value) => { setSelectedPrime(value); }}
                options={primeOptions}
                placeholder="Sélectionner une prime"
                className="text-sm"
              />
            </div>

            {/* Quantité */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Quantité</label>
              <input
                type="number"
                disabled={isLocked && !modificationApproved}
                min="0"
                value={quantitePrime}
                onChange={(e) => setQuantitePrime(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
              />
            </div>

            {/* Montant Prime */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Montant Prime</label>
              <input
                type="number"
                disabled={isLocked && !modificationApproved}
                min="0"
                value={montantPrime}
                onChange={(e) => setMontantPrime(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
              />
            </div>


            {/* Bouton Ajouter */}
            <div className="flex items-end">
             {editingPrimeId ? (
              <button onClick={handleUpdatePrime} className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                >Enregistrer</button>
              ) : (
              <button onClick={handleAddPrime} className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >Ajouter
              </button>
              )}

            </div>
          </div>
          )}



          <div className="border border-slate-200 rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-slate-200">
              <thead className="bg-slate-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Type</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Quantité</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Montant</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Total</th>
                  {!isPdfExporting && (
                  <th scope="col" className="px-6 py-3 text-xs font-medium text-slate-700 uppercase tracking-wider text-right">Actions</th>
                  )}
                </tr>
              </thead>
                <tbody className="bg-white divide-y divide-slate-100">
                  {primes.map((row) => (
                    <tr key={row.id} className="hover:bg-slate-50 transition-colors">
                      <td className="px-6 py-4 text-sm text-slate-700">{row.type}</td>
                      <td className="px-6 py-4 text-sm text-slate-700">{row.quantite}</td>
                      <td className="px-6 py-4 text-sm text-slate-700">{row.montant.toFixed(2)} €</td>
                      <td className="px-6 py-4 text-sm text-slate-700">{(row.quantite * row.montant).toFixed(2)} €</td>
                      {!isPdfExporting && (
                      <td className="px-6 py-4 text-right">
                        <div className="flex items-center justify-end space-x-3">
                          <button
                            onClick={() => startEditPrime(row)}
                            className="relative group text-slate-600 hover:text-blue-600 transition-colors"
                          >
                            <Pencil size={18} />
                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-slate-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                            Modifier
                            </div>
                          </button>

                          <button
                            onClick={() => handleDeletePrime(row.id)}
                            className="relative group text-slate-600 hover:text-red-600 transition-colors"
                          >
                            <Trash2 size={18} className="text-red-600 group-hover:text-red-700"/>
                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-slate-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                              Supprimer
                            </div>
                          </button>
                        </div>

                      </td>
                      )}
                    </tr>
                  ))}
                  {primes.length === 0 && (
                    <tr>
                      <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">
                        Aucun élément ajouté
                      </td>
                    </tr>
                  )}
                </tbody>

            </table>
          </div>
        </div>

        {/* Section indemnités */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
          <h3 className="text-2xl font-medium text-blue-600 mb-1">Indemnités</h3>
          <p className="text-sm text-slate-500 mb-5">Ces indemnités ne sont pas assujetties aux charges sociales.</p>
          {!isPdfExporting && (
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">

            {/* Select Indemnités */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Indemnités</label>
              <Select
                value={selectedIndemnite}
                disabled={isLocked && !modificationApproved}
                onChange={(value) => { setSelectedIndemnite(value); }}
                options={indemniteOptions}
                placeholder="Sélectionner une indemnité"
                className="text-sm"
              />
            </div>

            {/* Quantité */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Quantité</label>
              <input
                type="number"
                disabled={isLocked && !modificationApproved}
                min="0"
                value={quantiteIndemnite}
                onChange={(e) => setQuantiteIndemnite(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
              />
            </div>

            {/* Montant Indemnité */}
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Montant Indemnité</label>
              <input
                type="number"
                disabled={isLocked && !modificationApproved}
                min="0"
                value={montantIndemnite}
                onChange={(e) => setMontantIndemnite(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="0.00"
              />
            </div>

            <div className="flex items-end">
              {editingIndemniteId ? (
                <button
                  onClick={handleUpdateIndemnite}
                  className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                >
                  Enregistrer
                </button>
                ) : (
                <button
                  onClick={handleAddIndemnite}
                  className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                >
                  Ajouter
                </button>
                )}
                </div>

            </div>
          )}



          <div className="border border-slate-200 rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-slate-200">
              <thead className="bg-slate-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Type</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Quantité</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Montant</th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-slate-700 uppercase tracking-wider">Total</th>
                  {!isPdfExporting && (
                  <th scope="col" className="px-6 py-3 text-xs font-medium text-slate-700 uppercase tracking-wider text-right">Actions</th>
                  )}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-slate-100">
  {indemnites.map((row) => (
    <tr key={row.id} className="hover:bg-slate-50 transition-colors">
      <td className="px-6 py-4 text-sm text-slate-700">{row.type}</td>
      <td className="px-6 py-4 text-sm text-slate-700">{row.quantite}</td>
      <td className="px-6 py-4 text-sm text-slate-700">{row.montant.toFixed(2)} €</td>
      <td className="px-6 py-4 text-sm text-slate-700">{(row.quantite * row.montant).toFixed(2)} €</td>
      {!isPdfExporting && (
      <td className="px-6 py-4 text-right">
        <div className="flex items-center justify-end space-x-3">
          <button
            onClick={() => startEditIndemnite(row)}
            className="relative group text-slate-600 hover:text-blue-600 transition-colors"
          >
            <Pencil size={18} />
            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-slate-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              Modifier
            </div>
          </button>

          <button
            onClick={() => handleDeleteIndemnite(row.id)}
            className="relative group text-slate-600 hover:text-red-600 transition-colors"
          >
            <Trash2 size={18} className="text-red-600 group-hover:text-red-700"/>
            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-gray-700 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              Supprimer
            </div>
          </button>
        </div>
      </td>
      )}
    </tr>
  ))}

  {indemnites.length === 0 && (
    <tr>
      <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">
        Aucun élément ajouté
      </td>
    </tr>
  )}
</tbody>


            </table>
          </div>
        </div>
        
        {/* Section commentaires */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
            <h3 className="text-sm font-medium text-slate-700 mb-3">Commentaire du client</h3>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800 whitespace-pre-wrap">{clientComment}</p>
            ) : (
              <textarea
                className="w-full h-24 px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={clientComment}
                disabled={isLocked && !modificationApproved}
                onChange={(e) => setClientComment(e.target.value)}
                placeholder="Saisissez un commentaire..."
              ></textarea>
            )}
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
            <h3 className="text-sm font-medium text-slate-700 mb-3">Commentaire de l'intérimaire</h3>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800 whitespace-pre-wrap">...</p>
            ) : (
            <textarea
              className="w-full h-24 px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Pour information, voici le commentaire de l'intérimaire"
              disabled={isLocked && !modificationApproved}
            ></textarea>
            )}
          </div>
        </div>



        {/* Évaluation de l'intérimaire */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 mb-6">
          <h3 className="text-2xl font-medium text-slate-800 mb-4">Évaluation de l'intérimaire</h3>

          <div className="mb-4">
            <label className="block text-sm font-medium text-slate-700 mb-2">Note du client</label>
            <div className="flex space-x-2 mb-2">
              {[1, 2, 3, 4, 5].map((rating) => (
                <button
                  key={rating}
                  onClick={() => setClientRating(rating)}
                  className={`w-10 h-10 rounded-full flex items-center justify-center border transition-all ${clientRating >= rating ? 'bg-amber-100 border-amber-400 text-amber-600' : 'border-slate-300 text-slate-400 hover:border-slate-400'}`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Commentaire sur l'évaluation</label>
            {isPdfExporting ? (
              <p className="text-sm text-slate-800 whitespace-pre-wrap">{clientRatingComment}</p>
            ) : (
            <textarea
              className="w-full h-24 px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={clientRatingComment}
              disabled={isLocked && !modificationApproved}
              onChange={(e) => setClientRatingComment(e.target.value)}
              placeholder="Points forts, points à améliorer, conseils..."
            ></textarea>
            )}
          </div>

        </div>
         {/* Information de saisie et statut */}
        <div className="bg-slate-100 p-4 rounded-xl border border-slate-200 mb-6 text-sm text-slate-600 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <span className="font-medium text-slate-700">Saisi par :</span> Dupont Jean (Agent administratif)
            </div>
            <div>
              <span className="font-medium text-slate-700">Date d'envoi à l'agence :</span> 09/04/2025 à 14:30
            </div>
            <div>
              <span className="font-medium text-slate-700">Date de validation par l'agence :</span> 09/04/2025 à 14:30
            </div>

          </div>
        </div>
        {!isPdfExporting && (
          <div className="flex justify-end space-x-3">

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('🖱️ Clic sur le bouton Enregistrer');
                  console.log('📊 Statut actuel:', timeSheet?.status);
                  console.log('⏳ isLoading:', isLoading);
                  handleSave();
                }}
                disabled={isLoading || (timeSheet && (timeSheet.status === "a_valider" || timeSheet.status === "integrated"))}
                className={`inline-flex items-center px-4 py-2 border rounded-lg shadow-sm text-sm font-medium text-white transition-colors
                ${(isLoading || (timeSheet && (timeSheet.status === "a_valider" || timeSheet.status === "integrated"))) ? "bg-slate-400 cursor-not-allowed border-slate-400" : "bg-green-600 hover:bg-green-700 border-green-600"}`}
              >
                {isLoading ? "Enregistrement..." : "Enregistrer"}
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  sendToAgency();
                }}
                disabled={isLoading || timeSheet.status === "a_valider" || timeSheet.status === "integrated"}
                className={`inline-flex items-center px-4 py-2 border rounded-lg shadow-sm text-sm font-medium text-white transition-colors
                ${(isLoading || timeSheet.status === "a_valider" || timeSheet.status === "integrated") ? "bg-slate-400 cursor-not-allowed border-slate-400" : "bg-blue-600 hover:bg-blue-700 border-blue-600"}`}
              >
                {isLoading ? "Envoi..." : "Envoyer vers l'agence"}
              </button>

              <button
                onClick={downloadTimeSheet}
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
                Télécharger
              </button>

              <button
                onClick={handleModificationRequest}
                disabled={!isLocked || modificationRequested}
                className={`inline-flex items-center px-4 py-2 border rounded-lg shadow-sm text-sm font-medium text-white transition-colors
                ${(!isLocked || modificationRequested)
                ? "bg-slate-400 cursor-not-allowed border-slate-400"
                : "bg-slate-600 hover:bg-slate-700 border-slate-600"}`}
              >
                {modificationRequested ? "Demande envoyée" : "Demande de modification"}
              </button>
            </div>     
           )}
     

          </>
        )}
      </main>
      </div>
    </div>
  );
};

export default RelevesHeures;